
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../firebase/config";
import { collection, getDocs, query, where, updateDoc, doc, addDoc,increment } from "firebase/firestore";

// Fetch user orders
export const fetchOrders = createAsyncThunk("orders/fetchOrders", async (userId) => {
  console.log("Fetching orders...");
  const ordersRef = collection(db, "orders");
  const q = query(ordersRef, where("userId", "==", userId));
  const querySnapshot = await getDocs(q);

  return querySnapshot.docs.map((doc) => {
    const data = doc.data();
    return {
      id: doc.id,
      ...data,
      createdAt: data.createdAt?.toDate()?.toISOString() || null, // Convert Timestamp to ISO string
    };
  });
});

// Cancel order
export const cancelOrder = createAsyncThunk("orders/cancelOrder", async (orderId) => {
  const orderRef = doc(db, "orders", orderId);
  // await deleteDoc(orderRef);
  await updateDoc(orderRef, { orderedStatus: "Cancelled" });
  return orderId;
});

// Submit review and update order state locally
export const submitReview = createAsyncThunk(
  "orders/submitReview",
  async ({ orderId, productId, rating, text, images,currentUser ,orderduser}, { getState }) => {
    console.log("Submitting review for:", productId);
   
    const username = currentUser?.displayName || orderduser;
    const photoURL = currentUser?.photoURL || "";
    const productRef = doc(db, "products", productId);
    const reviewsRef = collection(productRef, "reviews");
    await updateDoc(productRef, {
      totalPeopleReview: increment(1), 
      totalRating: increment(rating)  
    });
    
    await addDoc(reviewsRef, { rating, text, images, createdAt: new Date(),user:username,photo:photoURL, id:currentUser.uid });
    const orderRef = doc(db, "orders", orderId);
    const { orders } = getState().orders;

    
    const updatedOrders = orders.map((order) => {
      if (order.id === orderId) {
        return {
          ...order,
          productOrdered: order.productOrdered.map((product) =>
            product.productID === productId ? { ...product, review: true } : product
          ),
        };
      }
      return order;
    });

    // Update Firestore
    await updateDoc(orderRef, {
      productOrdered: updatedOrders.find((order) => order.id === orderId).productOrdered,
    });
    
    return { orderId, productId };
  }
);

const orderSlice = createSlice({
  name: "orders",
  initialState: {
    orders: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.orders = state.orders.map((order) =>
          order.id === action.payload ? { ...order, orderedStatus: "Cancelled" } : order
        );
      })
      .addCase(submitReview.fulfilled, (state, action) => {
        const { orderId, productId } = action.payload;
        state.orders = state.orders.map((order) =>
          order.id === orderId
            ? {
              ...order,
              productOrdered: order.productOrdered.map((product) =>
                product.productID === productId ? { ...product, review: true } : product
              ),
            }
            : order
        );
      });
  },
});

export default orderSlice.reducer;
